import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { sendPhoneOtp, verifyOtp } from "@ui/Auth/api";
import { getSingleRecord } from "@ui/ComponentUtils/blueprintAPIs";
import { StyledTextField } from "components/common/style-components/TextField/MuiTextField.component";
import enums from "config/enums";
import { isEmpty, toString } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { MdVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAppApi } from "store/api-context";
import { useAppAuth } from "store/auth-context";
import { getAuthPath, getMainClient } from "utils/common/common.utils";
import { signupForm } from "utils/forms-constants/forms-constants.util";
import { errorToast, successToast } from "utils/toaster/toaster.util";
import * as yup from "yup";
import { deleteUserRecord } from "./api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const schema = yup.object({
  mobile: yup.string().required("mobile number is required").min(10).max(10),
});

const DeleteUserPage = () => {
  const mainClient = getMainClient();
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState();
  const [isMobileOTPsent, setIsMobileOTPsent] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [isConfirmationTextValid, setIsConfirmationTextValid] = useState("");
  const [userDetails, setUserDetails] = useState({});

  const { isMobileVerified, setIsMobileVerified } = useAppAuth();

  const navigate = useNavigate();
  const { fetchOverview, state } = useAppApi();

  const schema = yup.object({
    mobile: yup.string().required("mobile number is required").min(10).max(10),

    [signupForm.confirmation_text]: yup
      .string()
      .oneOf([`${userDetails?.firstName}`], "Confirmation text must match"),
  });

  const {
    control,
    formState: { errors },
    getValues,
    trigger,
    setValue,
    setError,
    reset,
  } = useForm({
    defaultValues: {},
    mode: "all",
    resolver: yupResolver(schema),
  });
  const data = getValues();

  const { isMobileVerifySend, isOTPFilled } = useMemo(() => {
    return {
      isMobileVerifySend:
        !errors[signupForm.mobile]?.message && !isEmpty(data?.mobile),
      isOTPFilled: !isEmpty(data?.otp),
    };
  }, [errors, data]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeNumber = async () => {
    setIsMobileVerified(false);
  };

  const sendMobileOTP = async (mobile) => {
    try {
      await sendPhoneOtp(mobile, {
        throwIfUserExist: false,
        client: mainClient?.id,
      });
      setIsMobileOTPsent(true);

      setIsMobileVerified(false);
      successToast("Otp has been sent successfully");
    } catch (err) {
      errorToast(err?.response?.data?.message);
    }
  };

  const fetchCurrentUser = async (phone, client) => {
    try {
      const userData = await getSingleRecord(enums.models.users, {
        phone: phone,
        client: mainClient?.id,
      });
      setUserDetails(userData);
    } catch (err) {
      errorToast(err?.response?.data?.message);
    }
  };

  const verifyMobileOTP = async (phone, code) => {
    try {
      await verifyOtp(phone, code);
      await fetchCurrentUser(phone);
      successToast("OTP has been verified");
      setIsMobileVerified(true);
      setIsMobileOTPsent(false);
      setValue(signupForm.otp, "");
    } catch (err) {
      setIsMobileVerified(false);
      errorToast(err?.response?.data?.message);
    }
  };

  const handleSendOtp = async () => {
    if (isMobileVerifySend) {
      sendMobileOTP(data?.mobile);
    }
  };

  const handleDeleteUser = async () => {
    const isFormValid = await trigger();
    console.log("isFormValid", isFormValid);
    if (!isMobileVerified) {
      return toast("You must validate your mobile number", {
        style: {
          background: "#FF6600",
          padding: "4px",
          color: "#fff",
        },
      });
    }

    try {
      if (isFormValid && isMobileVerified) {
        const data = getValues();

        await deleteUserRecord(data?.mobile, mainClient.id, userDetails?.code);
        setIsMobileVerified(false);
        setIsMobileOTPsent(false);
        toast.success("user has been deleted successfully");
        navigate(getAuthPath());
      }
    } catch (err) {
      setIsMobileVerified(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const handleUserDelete = () => {
    setConfirmationModal(true);
  };
  const handleVerify = (otp) => {
    const otpLength = otp?.length > 4 || otp?.length < 4;

    if (!otpLength && otp !== "") {
      verifyMobileOTP(data?.mobile, otp);
    } else {
      setError("otp", {
        type: "manual",
        message: "OTP must be typed",
      });
    }
  };
  const handleConfirmationTextChange = (event) => {
    setConfirmationText(event.target.value);
  };

  const handleConfirmTextValidation = () => {
    const expectedText = userDetails?.firstName;
    if (confirmationText === expectedText) {
      setIsConfirmationTextValid("success");
    } else {
      setIsConfirmationTextValid("error");
    }
  };

  const handleDeleteAccount = () => {
    handleDeleteUser();
  };

  useEffect(() => {
    setIsMobileVerified(false);
  }, []);

  return (
    <Grid
      sx={{
        display: "flex",
        height: "100vh",
        margin: "100 auto",
      }}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      container
    >
      <Paper
        elevation={2}
        sx={{
          textAlign: "center",
          maxWidth: {
            xs: 300,
            md: 600,
          },
          padding: {
            xs: "10px",
            md: "40px",
          },
        }}
      >
        <div>
          <img
            src={state?.overviews[0]?.logo?.location}
            alt={state?.overviews[0]?.logo?.fileName}
            width={140}
            height={120}
          />
        </div>

        <div>
          <Grid
            container
            xs={12}
            alignItems="center"
            sx={{
              paddingLeft: {
                xs: 2,
                md: 6,
              },
              paddingRight: {
                xs: 2,
                md: 6,
              },
            }}
            spacing={{
              xs: 2,
              md: 4,
            }}
          >
            <Grid item xs={12}>
              <Typography
                className="login_title"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.4rem",
                  textTransform: "uppercase",
                  lineHeight: "1rem",
                  letterSpacing: "0.2rem",
                }}
              >
                Delete User
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                item
                xs={isMobileVerifySend && isMobileVerified === false ? 8 : 12}
                md={isMobileVerifySend && isMobileVerified === false ? 8 : 12}
              >
                <Controller
                  name={signupForm.mobile}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Stack alignItems="flex-start">
                      <StyledTextField
                        fullWidth
                        id={signupForm.mobile}
                        data-testid={signupForm.mobile}
                        label="Mobile"
                        value={value}
                        onChange={onChange}
                        disabled={isMobileVerified}
                        error={!!errors[signupForm.mobile]?.message}
                        helperText={toString(
                          errors[signupForm.mobile]?.message
                        )}
                        InputProps={{
                          endAdornment: isMobileVerified ? (
                            <MdVerified style={{ color: "green", size: 6 }} />
                          ) : null,
                        }}
                      />
                      <Typography
                        onClick={handleChangeNumber}
                        sx={{
                          cursor: "pointer",
                          color: "#A54201",
                          fontWeight: 800,
                          fontSize: "0.8rem",
                          marginTop: "2px",
                        }}
                      >
                        {isMobileVerified
                          ? "Want to change mobile number?"
                          : ""}
                      </Typography>
                    </Stack>
                  )}
                />
              </Grid>
              {isMobileVerifySend && isMobileVerified === false ? (
                <Grid item xs={4}>
                  <Button onClick={handleSendOtp}>
                    {isMobileOTPsent ? "Resend otp" : "Send otp"}
                  </Button>
                </Grid>
              ) : null}
            </Grid>
            {isMobileOTPsent ? (
              <Grid
                item
                xs={12}
                md={12}
                container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid item xs={8}>
                  <Controller
                    name={signupForm.otp}
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <StyledTextField
                        fullWidth
                        required
                        id={signupForm.otp}
                        data-testid={signupForm.otp}
                        label="OTP"
                        value={otp}
                        onChange={(e) => {
                          setOtp(e?.target?.value);
                        }}
                        error={!!errors[signupForm.otp]?.message}
                        helperText={toString(errors[signupForm.otp]?.message)}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Button onClick={() => handleVerify(otp)}>Verify otp</Button>
                </Grid>
              </Grid>
            ) : null}

            <Grid item xs={12}>
              <Button
                disabled={!isMobileVerified}
                className="font-600"
                variant="contained"
                color="error"
                sx={{
                  color: "#fff",
                }}
                margin="unset"
                marginTop="0px"
                extraStyles={{
                  width: "100%",
                }}
                type="submit"
                onClick={handleUserDelete}
              >
                Delete user
              </Button>
            </Grid>
          </Grid>
        </div>
      </Paper>

      {confirmationModal ? (
        <Dialog
          open
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setConfirmationModal(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Delete User Account for {userDetails?.firstName}{" "}
            {userDetails?.lastName}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography variant="body1" color="error">
                <strong>Warning:</strong> Are you sure you want to delete your
                user account?
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#757575",
                  marginTop: "1rem",
                }}
              >
                <b>{userDetails?.firstName}</b> deleting your account will
                permanently remove all your data and information associated with
                the account. This action cannot be undone.
              </Typography>
            </DialogContentText>

            <Typography
              variant="body2"
              sx={{
                color: "#757575",

                marginTop: "1rem",
                marginBottom: "0.5rem",
              }}
            >
              Please type{" "}
              <code
                style={{
                  backgroundColor: "#C7C7C7",
                  padding: "1px 12px",
                  borderRadius: "3px",
                }}
              >
                {userDetails?.firstName}
              </code>{" "}
              for deleting your account
            </Typography>

            <Controller
              name={signupForm.confirmation_text}
              control={control}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <StyledTextField
                  fullWidth
                  required
                  id={signupForm.confirmation_text}
                  data-testid={signupForm.confirmation_text}
                  label="Confirmation for delete"
                  value={value}
                  onChange={onChange}
                  error={!!errors[signupForm.confirmation_text]?.message}
                  helperText={toString(
                    errors[signupForm.confirmation_text]?.message
                  )}
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setConfirmationModal(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteAccount}
              variant="contained"
              color="error"
              sx={{
                color: "#fff",
              }}
            >
              Delete Account
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default DeleteUserPage;
